import * as React from "react";

import { formatDate, formatSecure3d } from "app/utils/filters";
import BackOfficeAndSnapminLink from "app/components/BOComponents/BackOfficeAndSnapminLink";
import SnapminLink from "app/components/BOComponents/SnapminLink";
import { ColumnConfig } from "app/components/AppComponents/ConfigurableTable";

const columnConfigs: ColumnConfig[] = [
  {
    name: "Date",
    render: row => formatDate(row.created_at)
  },
  {
    name: "Auth ref",
    render: row => row.auth_reference
  },
  {
    name: "Bank response code",
    render: row => row.authorization_code
  },
  {
    name: "BIN",
    render: row => row.bin
  },
  {
    name: "BIN info",
    render: row => row.bin_info
  },
  {
    name: "Country code",
    render: row => row.country_code
  },
  {
    name: "Message",
    render: row => row.message
  },
  {
    name: "Ext. reference",
    render: row => row.external_reference
  },
  {
    name: "PSP",
    render: row => row.psp
  },
  {
    name: "PSP ref",
    render: row => row.psp_reference
  },
  {
    name: "Snapmin",
    render: row => <SnapminLink snapminUrl={row.snapmin_url} />
  },
  {
    name: "Status",
    render: row => row.status
  },
  {
    name: "Payment strategy",
    render: row => (
      <BackOfficeAndSnapminLink
        backofficeUrl={`/snapscan/ops/payments/${row.reference}/summary`}
        snapminUrl={row.snapmin_url}
      >
        {row.payment_strategy}
      </BackOfficeAndSnapminLink>
    )
  },
  {
    name: "User",
    render: row => (
      <BackOfficeAndSnapminLink
        backofficeUrl={`/snapscan/ops/users/${
          row.device.user.external_reference
        }/payments`}
        snapminUrl={row.device.user.snapmin_url}
      >
        {row.device.user.email}
      </BackOfficeAndSnapminLink>
    )
  },
  {
    name: "Device",
    render: row => (
      <BackOfficeAndSnapminLink
        backofficeUrl={`/snapscan/ops/devices/${
          row.device.external_reference
        }/summary`}
        snapminUrl={row.device.snapmin_url}
      >
        {row.device.phone_number || "-"}
      </BackOfficeAndSnapminLink>
    )
  },
  {
    name: "Secure 3D",
    render: row => formatSecure3d(row.secure3d_requested)
  }
];

export default columnConfigs;
